import { Pipe, PipeTransform } from '@angular/core';

import { Info } from 'luxon';

@Pipe({
    name: 'monthNameShort',
    standalone: false
})
export class MonthNameShortPipe implements PipeTransform {
    transform(value: number): string {
        return Info.months('short')[value - 1];
    }
}
